import { render } from "./EntryDescription.vue?vue&type=template&id=ed0028b4&ts=true"
import script from "./EntryDescription.vue?vue&type=script&lang=ts"
export * from "./EntryDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__